var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{directives:[{name:"clock",rawName:"v-clock"}],attrs:{"name":"fade"}},[(_vm.isMobile)?_c(_vm.MobileComponent,{tag:"component",attrs:{"lazy":""}}):_c('Pc',{attrs:{"lazy":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }